import { Component, Input, OnInit } from '@angular/core';
import { MultiColumnModule } from '@app/models/content';

@Component({
  selector: 'app-multi-column',
  templateUrl: './multi-column.component.html',
  styleUrls: ['./multi-column.component.scss']
})
export class MultiColumnComponent implements OnInit {

  @Input() module: MultiColumnModule;

  columnSizes: string[];

  constructor() { }

  ngOnInit() {
    this.columnSizes = this.module.format.split('_');
  }

}
